import React from 'react';

import styles from './BannerList.module.less';
import Header from '../Header';
import GameLink from '../GameLink';

export default ({ title, operate, to, tag: source, data = [] }) => {
  return (
    <div className={styles.BannerList}>
      <Header
        title={title}
        operate={operate === '2' ? '2' : '0'}
        to={to}
        source={source}
      />
      <nav>
        {
          data
            .map(banner => {
              return (
                <GameLink
                  key={banner.pageCardContentId}
                  info={banner}
                  source={source}
                  logInfo={{
                    category: 'C',
                    action: 'Game_Non_Button',
                    params: {
                      id: banner.pageCardContentId || '',
                      type: 'zt',
                      source,
                    },
                    bizInfo: banner.bizInfo,
                  }}>
                  <header>
                    <b style={{backgroundImage: `url("${banner.contentImg}")`}}></b>
                  </header>
                </GameLink>
              )
            })
        }
      </nav>
    </div>
  );
};
